"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Separator } from "@/components/ui/separator";
import { Facebook, Instagram, Twitter, Linkedin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-5 w-16 bg-muted-dark-background/40 animate-pulse rounded-md" />
        <div className="h-5 w-16 bg-muted-dark-background/40 animate-pulse rounded-md" />
        <div className="h-5 w-16 bg-muted-dark-background/40 animate-pulse rounded-md" />
      </div>;
  }
  const filteredMenuItems = menuItems.filter(item => item.label !== "Lodging Amenities");
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-wrap gap-6">
        {filteredMenuItems.map((item, i) => <NavigationMenuItem key={item.id}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} data-index={i === 0 ? 0 : undefined} className="text-foreground-dark/80 hover:text-foreground-dark text-sm font-medium transition-colors duration-[var(--duration-fast)]">
                {item.label === "San Juan River" ? "Home" : item.label.toLowerCase() === "fly fishing website lodging options" ? "Lodging Options" : item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const {
    ref: mainRef,
    isVisible: mainVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: bottomRef,
    isVisible: bottomVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const socialLinks = [{
    icon: Facebook,
    href: "https://www.facebook.com/wildflyfishingnm/",
    label: "Facebook"
  }];
  return <footer id="footer" className="w-full bg-dark-background text-foreground-dark py-[var(--space-3xl)]">
      <div className="container">
        <div ref={mainRef} className={`flex flex-col md:flex-row items-center justify-between gap-[var(--space-2xl)] ${mainVisible ? "animate-fade-in-up" : "opacity-0"}`}>
          <div className="flex-shrink-0">
            <img src="https://wildflyfishingnm.com/wp-content/uploads/2026/03/Logo-V3-3.png" alt="Wild Fly Fishing LLC" className="!w-[100px] !h-[100px] !rounded-none" />
          </div>

          <div className="flex flex-col md:flex-row items-center gap-[var(--space-2xl)]">
            <MenuProvider menu_id="33">
              <FooterMenuConsumer />
            </MenuProvider>

            <div className="flex items-center gap-[var(--space-md)]">
              {socialLinks.map((social, i) => <Link key={social.label} to={social.href} newTab aria-label={social.label} data-index={i} className="flex items-center justify-center w-10 h-10 rounded-full bg-muted-dark-background/40 text-foreground-dark hover:bg-primary hover:text-foreground hover:scale-110 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                  <social.icon className="w-5 h-5" />
                </Link>)}
            </div>
          </div>
        </div>

        <Separator className="my-[var(--space-2xl)] bg-border-strong/20" />

        <div ref={bottomRef} className={`text-center text-sm text-foreground ${bottomVisible ? "animate-fade-in-up" : "opacity-0"}`}>
          © {new Date().getFullYear()} Wild Fly Fishing LLC. All rights reserved.
        </div>
      </div>
    </footer>;
}